import * as React from "react";
import { ArrowRight, Linkedin, Mail, MapPin, Phone, Share2, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
export default function ContactInfo() {
  const address = "123 Main St, Springfield";
  const phone = "(555) 123-4567";
  const email = "contact@effet-conseil.com";
  const quickLinks = [{
    title: "Accueil",
    path: "/"
  }, {
    title: "Certifications RNCP/RS",
    path: "/RncpRsCertificationsPage"
  }, {
    title: "Contact",
    path: "/ContactPage"
  }];
  return;
}